import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import logo from "../../images/ACS_CP250_Logo.png";

import {
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Avatar,
  CardMedia
} from "@material-ui/core";

import { InboxOutlined, MailOutlined } from "@material-ui/icons/";

const styles = theme => ({
  formCls: {
    width: "100%"
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60
  },
  avatarText: {
    boxSizing: "border",
    fontSize: "1.5rem",
    fontWeight: "bold",
    padding: "1.25rem",
    color: "whitesmoke"
  },
  drawer: {
    width: "16%",
    backgroundColor: "#6975c3",
    color: "white",
    padding: ".25rem"
  },
  toolbarHeader: {
    borderBottom: "1px solid black"
    // marginBottom: ".25rem"
  },
  logo: {
    alignSelf: "center",
    backgroundSize: "contain",
    height: "10rem",
    width: "92%",
    opacity: "0.75",
  }
});

class SideBar extends Component {
  constructor() {
    super();

    this.state = {
      hasError: true,
      selectedIndex: 0,
      displayName: "Bath and Body Works"
    };
  }

  handleSelectionEvent = id => {
    this.setState(
      {
        selectedIndex: id
      },
      () => this.props.selectionEvent(id)
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Drawer
          //    className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawer
          }}
          // anchor="right"
        >
          <div className={classes.toolbarHeader}>
            <Grid container alignItems="center">
              <CardMedia className={classes.logo} image={logo} title="ACS" />

              <span className={classes.avatarText}>
                {this.props.customerDetail.Name}
              </span>
            </Grid>
          </div>
          <Divider />
          <List>
            {[
              "Service Request",
              "Existing Orders",
              "Store History"
              // ,
              // "Work Order Details"
            ].map((text, index) => (
              <ListItem
                button
                key={text}
                value={index}
                onClick={() => this.handleSelectionEvent(index)}
                selected={this.state.selectedIndex === index}
              >
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxOutlined /> : <MailOutlined />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
    );
  }
}

export default withStyles(styles)(SideBar);
